import { useAuthStore, useNotificationSettingsStore } from 'src/common/store'
import { onSignalREvent } from '../../signalRBus'
import { useNotificationStore, useOrgStore } from 'src/stores'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import { NotificationType } from 'src/interfaces/notificationPreferences'
import { showCrossCenterNotification } from 'src/utils/notificationActions'

onSignalREvent(
  SIGNAL_R_SCOPES.notification,
  SIGNAL_R_MESSAGES.newNotification,
  (text) => {
    const parts = text.split('_')
    const authStore = useAuthStore()
    if (authStore.isSuperAdmin) return
    const notificationStore = useNotificationStore()
    const notificationSettingsStore = useNotificationSettingsStore()
    const orgStore = useOrgStore()
    const notificationType = parts[0] as NotificationType
    const notificationCenterId = parts[1]

    if (notificationType === NotificationType.Message) return

    const isTypeEnabled = notificationSettingsStore.isInAppEnabledForCenter(
      notificationType,
      notificationCenterId,
    )

    if (!isTypeEnabled) return

    const isSameCenter =
      !notificationCenterId ||
      notificationCenterId === authStore.currentCenterId

    if (isSameCenter) {
      notificationStore.handleNotificationReceived()
    } else {
      const isCrossCenterEnabled =
        notificationSettingsStore.isPushEnabledForCenter(notificationCenterId)

      if (isCrossCenterEnabled) {
        const center = orgStore.centers.find(
          (c) => c.id === notificationCenterId,
        )
        const centerName = center?.name || 'another center'

        showCrossCenterNotification(notificationCenterId, centerName)
      }
    }
  },
)
